import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getLiquidTemplates = async (
  token: string,
  baseUrl: string,
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/liquid_templates`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
